import { render } from "./LoadingPlaces.vue?vue&type=template&id=d1b06fac&scoped=true"
import script from "./LoadingPlaces.vue?vue&type=script&lang=js"
export * from "./LoadingPlaces.vue?vue&type=script&lang=js"

import "./LoadingPlaces.vue?vue&type=style&index=0&id=d1b06fac&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1b06fac"]])

export default __exports__